export const VERBS = {
  SCROLL: 'experienced',
  PAGE_VIEW: 'accessed',
  WATCH: 'played'
}

export const XAPI_STATEMENT_TEMPLATES = {
  MT3: 'mt3',
  PRIME: 'prime',
  HELIX: 'helix'
}

export const ALLOWED_PLAYER_EVENTS = {
  PLAYED_VIDEO: 'playedVideo',
  PAUSED_VIDEO: 'pausedVideo',
  PLAYING_VIDEO: 'playingVideo',
  COMPLETED_VIDEO: 'completedVideo'
}

/**
 * Word content HTML body or DraftJS body.
 * @param {object} content - content body.
 * @returns {number}
 */
export const countWords = (contentBody) => {
  if (contentBody?.html) {
    return contentBody?.html?.replace(/[^\w ]/g, '').split(/\s+/).length
  }

  if (!contentBody?.data?.blocks) {
    return 0
  }

  return contentBody.data.blocks.reduce((acc, value) => {
    const trimmed = value?.text?.trim()
    const wordCount = trimmed ? trimmed.split(' ').length : 0
    acc += wordCount
    return acc
  }, 0)
}

/**
 * Get group category, category and sub category from category path.
 * @param {Array<object>} categoryPath - content category path.
 * @returns {object}
 */
export const getContentCategoryFromPath = (categoryPath = []) => {
  const topic = categoryPath[2]
  const subject = categoryPath[1]
  const groupCategory = categoryPath[0]

  return {
    topicName: topic?.name || null,
    subjectName: subject?.name || null,
    groupName: groupCategory?.name || null
  }
}

/**
 * Get video playtime.
 * @param {{duration: number, position: number}} payload - Video position and duration.
 * @returns {string} - The play time.
 */
export const getPlayDuration = ({ duration = 0, position = 0 }) => {
  return `${position}/${duration}`
}

/**
 * Get playable content type using the document object.
 * @param {Document} document - Browser document object.
 * @returns {string} - Returns the media type detected on the content.
 */
export const getPlayableMediaType = (document) => {
  if (document.querySelector('.video-container')) {
    return 'video'
  } else if (document.querySelector('.audio-container')) {
    return 'audio'
  } else {
    return null
  }
}

/**
 * This is used to rate limit the pause event for media files.
 * If a video has been paused once in the last x seconds only one event would be recorded.
 * @param {number|null} lastPauseTimestamp
 * @returns {boolean}
 */
export const shouldTrackPause = (lastPauseTimestamp) => {
  if (!lastPauseTimestamp) {
    return true
  }

  const diff = (Date.now() - lastPauseTimestamp) / 1000

  if (diff < 10) {
    return false
  }

  return true
}
